import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CloneService } from 'src/app/services/clone.service';
import { BoardingPlaceDensityOfPeopleFactorValue, BoardingPlaceDensityOfPeopleFactor } from 'src/app/models/BoardingPlaceDensityOfPeopleFactor.model';
import { TransportMode } from 'src/app/models/transportMode.model';
import { BoardingPlaceDensityOfPeopleFactorData } from '../boarding-place-density-of-people-factor/BoardingPlaceDensityOfPeopleFactorData.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { Place } from 'src/app/models/Place.model';
import { LocationWaysFactor, LocationWaysFactorValue } from 'src/app/models/LocationWaysFactor.model';
import { LocationWaysFactorData } from './locationWaysFactorData.model';

@Component({
  selector: 'app-location-ways-factor',
  templateUrl: './location-ways-factor.component.html',
  styleUrls: ['./location-ways-factor.component.scss']
})
export class LocationWaysFactorComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('locationWaysFactor', this._formBuilder.array([]));
    this.form.setControl('locationWaysFactor', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('locationWaysFactor');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as LocationWaysFactorValue[];
    this.gridData=this.ConvertData(this.data.values);
  }
  asFormGroup(o: LocationWaysFactor): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: LocationWaysFactor;
  @Input('isEditable') isEditable: boolean;
  @Input('places') places: Place[];
  form: FormGroup;
  lascCtrl;
  matrix: LocationWaysFactorData[] = [];
  gridData: GridData=new GridData();

  ConvertData(values:LocationWaysFactorValue[]): GridData {
    for (let i = 0; i < values.length; i++) {
      const element = values[i];
      let boardingPlaceDensityOfPeopleFactorData:LocationWaysFactorData = new LocationWaysFactorData;
      boardingPlaceDensityOfPeopleFactorData.value=element.value;
      boardingPlaceDensityOfPeopleFactorData.placeId=element.placeId;
      boardingPlaceDensityOfPeopleFactorData.colId=1;
      this.matrix.push(boardingPlaceDensityOfPeopleFactorData);
    }


    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.places.length; i++) {
      const headerEntry =  this.places[i];
      rowHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    colHeaders.push(new IdValue(1,'felw'));

    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.matrix.sort((a, b) => a.colId - b.colId);
    grid.colProp = 'colId';
    grid.rowProp = 'placeId';
    grid.switchColWithRow = false;
    return grid;
  }
  normalize(temp: LocationWaysFactorData[]) {
    let tmp:LocationWaysFactorValue[]=[];
    for (let index = 0; index < temp.length; index++) {
      const element = temp[index];
      let tmpValue:LocationWaysFactorValue=new LocationWaysFactorValue;
      tmpValue.placeId=element.placeId;
      tmpValue.value=element.value;
      tmp.push(tmpValue);
    }
    this.data.values=tmp;
  }
  save()
  {
    
    let clonedGridData = this.cloneService.deepClone(this.gridData.matrix) as LocationWaysFactorData[];
    this.normalize(clonedGridData);
    
    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
